
import { MailSettings } from "@/models/mail-settings";
import { MailSettingsService } from "@/services/mail-settings-service";
import { DossierConfigService } from "@/services/dossier-config-service";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { IBreadCrumb } from "winfakt-vue-components";
import AppMailSettingsRenameModal from "@/components/settings-default/MailSettingsRenameModal.vue";
import { v4 } from "uuid";

interface IRecipientModeOption {
	key:string;
	value:boolean;
	text:TranslateResult;
	description:TranslateResult;
}

export default Vue.extend({
	data() {
		return {
			items: [] as MailSettings[],
			renameModalSettings: null as null | MailSettings,
			dossierConfig: DossierConfigService.getGeneralConfig()
		};
	},
	computed: {
		title():TranslateResult{
			return this.$ct("mails");
		},
		path():IBreadCrumb[]{
			return [
				{
					to: "/settings", value: this.$ct("general")
				},
				{value: this.title}
			] as IBreadCrumb[];
		},
		addMailSettingsDisabled():boolean{
			return this.items.length >= 20;
		},
		recipientModeOptions():IRecipientModeOption[]{
			return [
				{
					key: "first-to-rest-bcc",
					value: false,
					text: this.$ct("mail-recipients-first-to-rest-bcc"),
					description: this.$ct("mail-recipients-first-to-rest-bcc-description")
				},
				{
					key: "all-to",
					value: true,
					text: this.$ct("mail-recipients-all-to"),
					description: this.$ct("mail-recipients-all-to-description")
				}
			];
		}
	},
	methods: {
		async fetch(){
			this.items = await MailSettingsService.getSettings();
		},
		async onSendAllRecipientsAsToChanged(value:boolean){
			if (this.dossierConfig.MailSendAllRecipientsAsTo == value) return;
			this.dossierConfig.MailSendAllRecipientsAsTo = value;
			this.dossierConfig = await DossierConfigService.saveGeneralConfig(this.dossierConfig);
		},
		editItem(item:MailSettings){
			this.$router.push(`/settings/mails/edit/${item.ID}`);
		},
		async deleteItem(item:MailSettings){
			await MailSettingsService.deleteSettings(item);
			await this.fetch();
		},
		renameItem(item:MailSettings){
			this.renameModalSettings = item;
		},
		async setAsDefault(item:MailSettings){
			await MailSettingsService.setDefault(item);
			for (let item of this.items) {
				item.IsDefault = false;
			}
			item.IsDefault = true;
		},
		isLabelInUse(val:string):boolean{
			for (let item of this.items){
				if (item.Label == val){
					return true;
				}
			}
			return false;
		},
		addMailSettings(){
			let settings = new MailSettings();
			let label = this.$ct("new-mail-settings-name", {counter: ""}).toString().trim();
			let inUse = this.isLabelInUse(label);
			let counter = 1;
			while (inUse){
				label = this.$ct("new-mail-settings-name", {counter}).toString().trim();
				inUse = this.isLabelInUse(label);
				counter++;
				if (counter > 100) {
					label = this.$ct("new-mail-settings-name", {counter: v4()}).toString().trim();
					inUse = false;
				}
			}
			settings.Label = label;
			this.renameModalSettings = settings;
		},
		async onRenameModalConfirm(name:string){
			if (!this.renameModalSettings) return;
			let settings = this.renameModalSettings;
			if (settings.ID != 0){
				let s = new MailSettings(settings.getJSON());
				s.Label = name;
				s = await MailSettingsService.updateSettings(s, false);
				settings.Label = s.Label;
			}else{
				settings.Label = name;
				settings = await MailSettingsService.createSettings(settings);
				this.editItem(settings);
			}
		}
	},
	async mounted(){
		await this.fetch();
	},
	components: {
		AppMailSettingsRenameModal
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
